import z from "zod";
const USValidationSchema = z.object({
  zipCode: z.string().regex(/^\d{5}(?:[-\s]\d{4})?$/)
  // REGEX from https://stackoverflow.com/a/2577239
});
const US_FORMAT_CONFIGURATION = {
  inputMaskConfiguration: {
    patterns: ["00000", "00000-0000"]
  },
  maxCharacterLimit: 10,
  validationSchema: USValidationSchema
};
export {
  US_FORMAT_CONFIGURATION
};
